import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navbar from "../components/navbar";
import About from "../components/about";
import Features from "../components/features";

import GetInTuch from "../components/getInTuch";
import Footer from "../components/footer";

import Switcher from "../components/switcher";

import Beneficios from "../components/Beneficios";
import Ecosistema from "../components/Ecosistema";
import WordWide from "../components/WordWide";

import VideoBackground from "../components/VideoBackground";

import HubspotScript from "../components/husbspotScript";
import CarouselTestimonios from "../components/CarouselTestimonios";
import CertificacionesCarousel from "../components/CertificacionesCarousel";
import PalabrasCarousel from "../components/PalabrasCarousel";
import Cookie from "../components/Cookie";
import useStore from "../store/useStore";

export default function Index() {
  const location = useLocation();
  const { home, getHomeHero } = useStore();
  useEffect(() => {
    getHomeHero();
  }, [getHomeHero]);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  const urlApi = "https://api.institucional.global.sidom.io";
  return (
    <div className="relative overflow-hidden leading-[1.3] bg-sidom-light dark:bg-sidom-blue">
      <Navbar />
      {/* {hero} */}{" "}
      <div data-aos="fade-up">
        {home?.length === 0 || !home ? (
          <VideoBackground
            video="/placeholder.mp4"
            titulo1="Cargando..."
            titulo2="Espere un momento"
            textbutton="SOLICITAR DEMO"
            logo="/placeholder-logo.png"
          />
        ) : (
          home.map((item, index) => (
            <VideoBackground
              key={index}
              video={`${urlApi}${item.video[0]?.url}`}
              titulo1={item.titulo}
              titulo2={item.text}
              textbutton="SOLICITAR DEMO"
              logo={`${urlApi}${
                item.img?.formats?.thumbnail?.url ||
                item.img?.url ||
                "/placeholder-logo.png"
              }`}
            />
          ))
        )}
      </div>
      <About />
      <PalabrasCarousel />
      <div id="section-two" data-aos="fade-up" data-aos-delay="300">
        <Features />
      </div>
      <div data-aos="fade-up" data-aos-delay="400">
        <CarouselTestimonios />
      </div>
      <div data-aos="fade-up" data-aos-delay="500">
        <WordWide />
      </div>
      <div data-aos="fade-up" data-aos-delay="600">
        <Beneficios />
      </div>
      <CertificacionesCarousel />
      <Ecosistema />
      <GetInTuch />
      <Cookie />
      <HubspotScript />
      <Footer />
      <Switcher />
      {/* <OurProjects
          containerClass="container relative md:mt-24 mt-16"
          griedClass="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 mt-4 gap-[30px]"
        /> */}
      {/* <CarouselText /> */}
      {/* <TestimonioUser />
        <TestimonioMarcas /> */}
      {/* <Team /> */}
      {/* <Blog /> */}
      {/* <ContactUs /> */}
      {/* <section className="py-6 border-t border-b border-gray-100 dark:border-gray-700">
        <div className="container relative">
          <div className="grid md:grid-cols-6 grid-cols-2 justify-center gap-[30px]">
            {businessPartner.map((item, index) => {
              return (
                <div className="mx-auto py-4" key={index}>
                  <img src={item} className="h-6" alt="" />
                </div>
              );
            })}
          </div>
        </div>
      </section> */}
    </div>
  );
}
